<template>
  <!-- Состав заказа -->
  <div v-if="hasItems" class="order-items">
    <div class="order-items__header">
      <h4 class="order-section-title">Состав заказа</h4>
      <UiKitChip color="default" variant="flat" size="sm">
        {{ items.length }} {{ itemsCountLabel }}
      </UiKitChip>
    </div>

    <div class="order-items__list">
      <OrderItem
        v-for="item in items"
        :key="item.id"
        :item="item"
        :addons="addons"
        :excludes="excludes"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import OrderItem from './OrderItem.vue'
import type { Order } from '@entities/order'

interface Props {
  order: Order | null
  addons: any[]
  excludes: any[]
}

const props = defineProps<Props>()

/**
 * Получает позиции заказа
 */
const items = computed(() => {
  return props.order?.items ?? []
})

/**
 * Проверяет, есть ли позиции в заказе
 */
const hasItems = computed(() => {
  return props.order && Array.isArray(props.order.items) && props.order.items.length > 0
})

/**
 * Склонение слова «позиция» для чипа количества
 */
const itemsCountLabel = computed(() => {
  const count = items.value.length
  const mod10 = count % 10
  const mod100 = count % 100
  if (mod10 === 1 && mod100 !== 11) return 'позиция'
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'позиции'
  return 'позиций'
})
</script>

<style scoped lang="scss">
.order-items {
  @apply mt-2;

  &__header {
    @apply flex items-center justify-between gap-2 mb-1 pb-2 border-b border-hui-default-200;
  }

  &__list {
    @apply divide-y divide-hui-default-100;
  }
}

.order-section-title {
  @apply text-lg font-semibold text-hui-foreground;
}
</style>